import { defineStore } from 'pinia'
import { jwtDecode } from 'jwt-decode'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    jwt: null,
  }),

  getters: {
    isLoggedIn: (state) => {
      if (!state.jwt) return false
      try {
        const { exp } = jwtDecode(state.jwt)
        return exp * 1000 > Date.now()
      } catch {
        return false
      }
    },
    headers: (state) => {
      return {
        Authorization: `Bearer ${state.jwt}`,
      }
    },
    hasRole: (state) => (role) => {
      return state.user?.role === role
    },
  },

  actions: {
    setJWT(token) {
      this.jwt = token

      if (token) {
        localStorage.setItem('jwt', token)
      } else {
        localStorage.removeItem('jwt')
      }
    },

    setUser(user) {
      this.user = user
    },

    setUserFromJWT(token) {
      try {
        const payload = jwtDecode(token)
        this.user = {
          username: payload.username,
          role: payload.role,
          language: payload.language || 'fr',
        }
      } catch (error) {
        // Error decoding JWT
      }
    },

    login(token) {
      this.setJWT(token)
      this.setUserFromJWT(token)
    },

    logout() {
      this.setJWT(null)
      this.setUser(null)
    },

    initializeAuth() {
      const token = localStorage.getItem('jwt')
      if (token) {
        try {
          const { exp } = jwtDecode(token)
          if (exp * 1000 <= Date.now()) {
            this.logout()
            return
          }
        } catch {
          this.logout()
          return
        }
        this.setJWT(token)
        this.setUserFromJWT(token)
      }
    },
  },
})
